import React, { memo } from 'react';
import clsx from 'clsx';
import { isNil } from 'ramda';
import { makeStyles } from '@mui/styles';
import { Text, View } from '../../Base';

const useStyles = makeStyles(() => ({
  pointer: {
    cursor: 'pointer',
  },
}));

const BodyCell = ({
  value,
  firstIcon,
  lastIcon,
  classes,
  extraCellClasses = [],
  extraContainerClasses = [],
  extraLastIconClasses = [],
  testId = '',
  firstIconTestId = '',
  lastIconTestId = '',
  ...rest
}) => {
  const cellStyles = useStyles();

  return (
    <View
      className={clsx([
        classes.container,
        ...extraContainerClasses,
        rest.onClick && cellStyles.pointer,
        rest.disabled && classes.disabled,
      ])}
      {...rest}
    >
      {firstIcon && (
        <View className={classes.firstIcon} data-testid={firstIconTestId}>
          {firstIcon}
        </View>
      )}
      {!isNil(value) && (
        <Text
          noWrap
          className={clsx([classes.cellText, ...extraCellClasses])}
          data-testid={testId}
        >
          {value}
        </Text>
      )}
      {lastIcon && (
        <View
          className={clsx([classes.lastIcon, ...extraLastIconClasses])}
          data-testid={lastIconTestId}
        >
          {lastIcon}
        </View>
      )}
    </View>
  );
};

export default memo(BodyCell);
